export default function validateStrongPassword(value) {
  let strength = 0;

  if (value.length >= 4 && value.length <= 8) strength += 10;
  else if (value.length > 8) strength += 25;

  if (value.length >= 5 && value.match(/[a-z]+/)) strength += 10;
  if (value.length >= 8 && value.match(/[A-Z]+/)) strength += 20;
  if (value.match(/[!@#$%¨&*()_+]/)) strength += 25;

  return strength;
}
